import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainApp from './components/MainApp';
import PublicProfile from './components/PublicProfile';
import './App.css';

function App() {
  const [sharedProfileId, setSharedProfileId] = useState(null);

  useEffect(() => {
    // Check if URL contains a profile share (e.g., /profile/user-id or ?profile=...)
    const urlPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    
    // Handle direct profile links like /profile/user-id
    if (urlPath.startsWith('/profile/')) {
      const profileId = urlPath.split('/profile/')[1];
      if (profileId) {
        setSharedProfileId(profileId);
        return;
      }
    }
    
    // Handle query parameter fallbacks
    const friendName = urlParams.get('friend');
    const email = urlParams.get('email');
    
    if (friendName && email) {
      // For fallback friend sharing, we'd need to convert to user ID
      // For now, let's just redirect to main app
      console.log('Friend sharing fallback:', { friendName, email });
    }
  }, []);

  // If we have a shared profile ID, show the public profile directly
  if (sharedProfileId) {
    return (
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <PublicProfile userId={sharedProfileId} />
        </div>
      </AuthProvider>
    );
  }

  // Otherwise, show the normal protected app
  return (
    <AuthProvider>
      <ProtectedRoute>
        <MainApp />
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
